import { render, staticRenderFns } from "./sonAccountSelectRegion.vue?vue&type=template&id=6112c02e&"
import script from "./sonAccountSelectRegion.vue?vue&type=script&lang=js&"
export * from "./sonAccountSelectRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports